// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateTask_container__3tjcw","content":"CreateTask_content__JFDmV","title":"CreateTask_title__1A_OY","closeButton":"CreateTask_closeButton__1lKzA"};